import { useState } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, Container, IconButton, Toolbar } from '@mui/material';

import Logo from '~/components/Logo';
import UserActions from '~/components/UserActions';

import MobileMenu from './MobileMenu'; // Import the new MobileMenu component
import TopMenu from './TopMenu';

interface HeaderProps {
  isAuthenticated?: boolean;
}

function Header(_: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuOpen = () => setIsMenuOpen(true);

  const handleMenuClose = () => setIsMenuOpen(false);

  return (
    <AppBar className="main-header" position="static" sx={{ width: '100%', boxShadow: 'none' }}>
      <Container maxWidth="xl">
        <Toolbar
          className="content"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'nowrap',
            gap: { xs: 1, md: 0 },
            padding: { xs: '8px 16px', sm: '10px 24px', lg: '15px 32px' },
          }}
        >
          <Box
            className="logo-space"
            component={Link}
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexShrink: 1,
              minWidth: 0,
              '& svg': {
                maxWidth: '100%',
              },
            }}
            to="/"
          >
            <Logo />
          </Box>

          {/* Desktop menu */}
          <Box
            className="menu-space"
            sx={{
              flexGrow: 1,
              display: { xs: 'none', sm: 'none', md: 'flex' },
              justifyContent: 'center',
            }}
          >
            <TopMenu />
          </Box>

          {/* User actions */}
          <Box
            className="user-space"
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexBasis: 'auto',
              justifyContent: { xs: 'flex-end', md: 'initial' },
              minWidth: 0,
              flexShrink: 0,
              ml: 'auto',
              '& .MuiListItemText-root': {
                display: { xs: 'none', sm: 'block' },
              },
            }}
          >
            <UserActions />
          </Box>

          {/* Hamburger menu for mobile (below 900px) */}
          <Box
            sx={{
              display: { xs: 'flex', sm: 'flex', md: 'none' },
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <IconButton
              aria-controls={isMenuOpen ? 'mobile-navigation' : undefined}
              aria-expanded={isMenuOpen}
              aria-haspopup="true"
              aria-label="Open navigation menu"
              color="inherit"
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </Container>
      <MobileMenu handleClose={handleMenuClose} isOpen={isMenuOpen} />
    </AppBar>
  );
}

export default Header;
